import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class OrganizationAdapter extends ApplicationAdapter {}
